import type { CalendarDate } from '@internationalized/date';
import { Calendar } from '@heroui/react';

interface HeroUiCalendarGridProps {
  ariaLabel: string;
  value?: CalendarDate | null;
  onChange?: (value: CalendarDate) => void;
  minValue?: CalendarDate;
  maxValue?: CalendarDate;
  className?: string;
  /** Expande o calendário para a largura total do container (ex.: cards inline). */
  fullWidth?: boolean;
  /** Exibe indicador (ponto) em dias que retornam true — ex.: janelas de disponibilidade ativas. */
  hasCellIndicator?: (date: CalendarDate) => boolean;
  /** Impede seleção de dias que retornam true — ex.: dias ocupados por outra janela. */
  isDateUnavailable?: (date: CalendarDate) => boolean;
}

export function HeroUiCalendarGrid({
  ariaLabel,
  value,
  onChange,
  minValue,
  maxValue,
  className,
  fullWidth = false,
  hasCellIndicator,
  isDateUnavailable,
}: HeroUiCalendarGridProps) {
  return (
    <Calendar
      aria-label={ariaLabel}
      className={
        fullWidth ? `!w-full !max-w-none ${className ?? ''}`.trim() : className
      }
      value={value ?? undefined}
      onChange={onChange}
      minValue={minValue}
      maxValue={maxValue}
      isDateUnavailable={isDateUnavailable}
    >
      <Calendar.Header>
        <Calendar.YearPickerTrigger>
          <Calendar.YearPickerTriggerHeading />
          <Calendar.YearPickerTriggerIndicator />
        </Calendar.YearPickerTrigger>
        <Calendar.NavButton slot="previous" />
        <Calendar.NavButton slot="next" />
      </Calendar.Header>
      <Calendar.Grid>
        <Calendar.GridHeader>
          {(day) => <Calendar.HeaderCell>{day}</Calendar.HeaderCell>}
        </Calendar.GridHeader>
        <Calendar.GridBody>
          {(date) => (
            <Calendar.Cell date={date}>
              {(cell) => (
                <>
                  {cell.formattedDate}
                  {hasCellIndicator?.(date) ? <Calendar.CellIndicator /> : null}
                </>
              )}
            </Calendar.Cell>
          )}
        </Calendar.GridBody>
      </Calendar.Grid>
      <Calendar.YearPickerGrid>
        <Calendar.YearPickerGridBody>
          {({ year }) => <Calendar.YearPickerCell year={year} />}
        </Calendar.YearPickerGridBody>
      </Calendar.YearPickerGrid>
    </Calendar>
  );
}
